export default __webpack_public_path__ + "images/99.27b6cba.png";